import { type UseQueryResult, useQuery } from 'react-query';
import { OptionExerciseSharedService } from '../../services/wealthlane-award-services';

const useGetSettlementType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const settlementType = useQuery(
    ['getSettlementType'],
    async () => {
      return await handleRequest(
        OptionExerciseSharedService.getApiAwardApiAppOptionExerciseSettlementTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
            systemName: item.systemName ?? '',
          };
        });
      },
    }
  );
  return settlementType;
};

export default useGetSettlementType;
